import styled from 'styled-components'

export const Data = styled.span`
   display: flex;
`
export const Container = styled.div`
   display: flex;
   flex-direction: column;
   input{
      margin: .1rem;
   }
   div{
      margin: .1rem;
   }
`
//word-wrap: break-word;
//   width: 100px;